import { platformModeOverride } from 'config/app'
import { PLATFORM_MODE_STORAGE_KEY, PlatformMode } from 'constants/platformMode'
import { useAppDispatch, useAppSelector } from 'hooks/redux'
import { setPlatformMode } from 'store/slice/platformModeSlice'
import * as storage from 'helpers/storage'

export const usePlatformMode = () => {
  const dispatch = useAppDispatch()
  const selectedMode = useAppSelector((state) => state.platformMode.mode)
  const mode: PlatformMode = platformModeOverride ?? selectedMode

  return {
    mode,
    isTestSmarterMode: mode === PlatformMode.TestSmarter,
    isIRhythmMode: mode === PlatformMode.IRhythm,
    setMode: (value: PlatformMode) => {
      storage.set(PLATFORM_MODE_STORAGE_KEY, value)
      dispatch(setPlatformMode(value))
    },
  }
}

// HST duration is clinical: in iRhythm mode a DME doesn't choose the nights, and sets
// one set of conditions for all of them. Lab staff still choose.
export const useHstDurationFixed = (context?: 'LAB' | 'DME', testType?: string): boolean => {
  const { isIRhythmMode } = usePlatformMode()

  return context === 'DME' && isIRhythmMode && testType === 'HST'
}
